<template>
  <div>
    <el-dialog
      title="联系客服"
      :visible.sync="dialogVisible"
      width="20%"
      append-to-body
      >
      <div>
        <div style="margin-top: 10px">客服电话</div>
        <div>0768-2287798</div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
  </span>
    </el-dialog>

  </div>

</template>

<script>

import config from '@/config/config.js'

export default {
  data() {
    return {
      config: config,
      dialogVisible: false
    };
  },
  methods: {
    show(){
      this.dialogVisible=true;
    }
    // handleClose(done) {
    //   this.$confirm('确认关闭？')
    //     .then(_ => {
    //       done();
    //     })
    //     .catch(_ => {});
    // }
  }
};

</script>


<style lang="scss" scoped>

/deep/ .el-dialog .el-dialog__body{
  display: flex;
  justify-content: center;
  align-items: center;
  //width: 500px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/index.vue